import { Rating as MantineRating, type RatingProps } from '@mantine/core';
import { clsx } from 'clsx';
import { MdStar } from 'react-icons/md';
import { useFieldA11y } from '../../hooks/useFieldA11y';
import './RatePicker.scss';

export interface IRatePickerProps extends Omit<RatingProps, 'color' | 'count' | 'emptySymbol' | 'fullSymbol'> {
    /** Невалидный статус (текст ошибки рендерит FormGroup). */
    invalid?: boolean;
}

const getSymbolLabel = (value: number) => `Оценка ${value} из 5`;

const RatePicker = ({
    allowClear = true,
    className,
    getSymbolLabel: getSymbolLabelProp = getSymbolLabel,
    invalid,
    readOnly,
    size = 'lg',
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    ...props
}: IRatePickerProps) => {
    const fieldA11y = useFieldA11y({
        'aria-label': props['aria-label'],
        'aria-labelledby': ariaLabelledBy,
        'aria-describedby': ariaDescribedBy,
    });
    return (
        <MantineRating
            {...props}
            // звёзды — радиокнопки «Оценка N из 5»; группа названа подписью поля (в readOnly кнопок нет)
            role={readOnly ? undefined : 'radiogroup'}
            {...fieldA11y}
            allowClear={allowClear}
            aria-invalid={invalid || undefined}
            aria-readonly={readOnly || undefined}
            className={clsx('rf-rate-picker', invalid && 'rf-rate-picker--invalid', className)}
            count={5}
            emptySymbol={<MdStar aria-hidden="true" className="rf-rate-picker__star rf-rate-picker__star--empty" />}
            fullSymbol={<MdStar aria-hidden="true" className="rf-rate-picker__star rf-rate-picker__star--full" />}
            getSymbolLabel={getSymbolLabelProp}
            readOnly={readOnly}
            size={size}
        />
    );
};

export default RatePicker;
